import { VFC } from 'react'
import { formatFilesize } from '@opallabs/lambda'
import { Icon } from '@opallabs/lapidary'
import { MemoizedPopover } from '../../../../components/ControlBar/MemoizedPopover'
import { useTextEditor } from '../../../../context'
import { AssetNodeChildProps } from '../../types'
import * as styles from './styles'

const AssetResourceNode: VFC<AssetNodeChildProps> = ({
  asset,
  onDelete,
  readOnly,
}) => {
  const { theme } = useTextEditor()

  return (
    <div css={styles.nodeViewWrapper}>
      <div
        css={styles.resource({ theme })}
        className="texteditor-asset-resource"
        data-disabled={readOnly}
      >
        <a
          css={styles.resourceLink({ theme })}
          download={asset.filename}
          href={asset.fullUrl ?? undefined}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon glyph="gem-file" ariaHidden />
          <span css={styles.filename}>{asset.filename}</span>
        </a>

        <div className="hover-container">
          <span css={styles.filesize}>{formatFilesize(asset.filesize, 0)}</span>
          {!readOnly && (
            <MemoizedPopover label="Delete File">
              <button
                css={styles.deleteResource({ theme })}
                onClick={() => onDelete()}
                aria-label="Delete File"
              >
                <Icon glyph="gem-trash" ariaHidden />
              </button>
            </MemoizedPopover>
          )}
        </div>
      </div>
    </div>
  )
}

export default AssetResourceNode
